import { faBadge, faCheck, faPaperPlane as fasPaperPlane } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { BasicSuccessPage } from "@component/assets/AbstractLeadForm/Steps/BasicSuccessPage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { List, ProgressButton, Stack } from "@shared/ui";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export class SuccessPage extends BasicSuccessPage {
	protected renderContent(): ReactNode {
		return (
			<>
				<Card.Header className="text-center py-3">
					<Card.Title>Köszönjük, hogy leadtad érdeklődésed!</Card.Title>
				</Card.Header>
				<Card.Body className="bg-gray py-3" style={{ flex: "unset" }}>
					<Stack direction="horizontal" gap={3} alignItems="center">
						<div>
							<div className="fa-stack fa-2x">
								<FontAwesomeIcon icon={faBadge} className="fa-stack-2x text-blue" />
								<FontAwesomeIcon icon={faCheck} className="fa-stack-1x fa-inverse" />
							</div>
						</div>
						<div className="h5 mb-0">Hamarosan elküldjük neked a kalkulációd eredményeit</div>
					</Stack>
					<hr />
					<div className="text-center">
						Ha addig is további kérdésed lenne, írj nekünk a{" "}
						<a href="mailto:bankmonitor@bankmonitor.hu">bankmonitor@bankmonitor.hu</a> címre.
					</div>
				</Card.Body>
				{this.renderSubscribe()}
			</>
		);
	}

	protected renderSubscribe(): ReactNode {
		const { withoutSubscribe } = this.props;
		const { subscirbeState } = this.state;

		if (withoutSubscribe) {
			return null;
		}

		return (
			<>
				<Card.Body className="py-4">
					<div className="h5 text-center">Ne maradj le hírlevelünkről!</div>
					<List itemStyle="tick" variant="blue">
						{this.renderSubscribeList()}
					</List>
				</Card.Body>
				<Card.Footer className="text-center bg-transparent">
					<ProgressButton
						className="mt-2 font-weight-bold"
						icon={<FontAwesomeIcon icon={fasPaperPlane} />}
						state={subscirbeState}
						onClick={this.onSubscribeClick}
					>
						Feliratkozás
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	protected renderSubscribeList(): ReactNode {
		return (
			<>
				<List.Item>
					<strong>Legfontosabb változások</strong> a hitel és megtakarítási lehetőségek piacán
				</List.Item>
				<List.Item>Hogyan spórolhatsz bankköltségeiden</List.Item>
				<List.Item>
					<strong>Ötletek, javaslatok</strong> hogyan hozz ki többet anyagi helyzetedből
				</List.Item>
			</>
		);
	}

	protected getClassName(): string {
		return "small-calculator-step card text-body";
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.SuccessPage`;
	}
}
